module.exports = __webpack_public_path__ + "static/media/Walk-through_Add-post_4.3cd9a59d.jpg";